import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingSimulatorStaff extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      hours: '',
      double_paid: '',
      disapproved: 0,
      status: 0,
    };

    this.locale = getLocale();

    //bind específico
    this.generatePayment = this.generatePayment.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    var valido = /^[\d,.]+$/.test(event.target.value);
    if (event.target.value === "" || valido === true) {
      var self = this;
      change[name] = event.target.value
      this.setState(change);
    }
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_staff_id !== 'undefined')){
      this.setState({
        hours: newProps.hours,
        status: newProps.status,
        id: newProps.training_certification_staff_id,
        loaded: 1,
      });
    }
  }

  // Fetch salvando resultado do aluno
  generatePayment(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      double_paid: this.state.double_paid,
      hours: this.state.hours,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/instrutor/examinador/gerar_pagamento_horas', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <form onSubmit={this.generatePayment}>
          <table className="table">
            <thead>
              <tr>
                <th>{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaIntrutoresExaminadores.formulario.Horas}</th>
                <th>{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaIntrutoresExaminadores.formulario.HorasDobradas}</th>
                <th>{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaIntrutoresExaminadores.formulario.Acoes}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                  <td>
                    {this.state.hours}
                  </td>
                  <td>
                    {this.state.double_paid}
                  </td>
                  <td>
                    <button disabled={this.state.status == 1 ? "disabled" : ""} type="submit" className="btn btn-success btn-block"><i className="fa fa-fw fa-dollar"></i> {this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaIntrutoresExaminadores.formulario.botaoConfirmarPagamento}</button>
                  </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    );
  }
}

export default TrainingSimulatorStaff;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffPayment.js